import { Todo } from 'owa-todo-types';
import { isSameDay, today } from 'owa-datetime';

// TODO VSO 78581: handle day changes and timezone changes for the my day list in the task tab of the time panel
export function isMyDayTask(todo: Todo): boolean {
    return !!todo.CommittedDay && isSameDay(todo.CommittedDay, today());
}
